import React from 'react'
import useCurrentUser from '../../../hooks/use-current-user'
import { useAuth0 } from '@auth0/auth0-react'
import { BoxArrowRight, BoxArrowInRight } from 'react-bootstrap-icons'
import NavIconButton from '../nav-icon-button'

const NavLogin = () => {
    const { loginWithRedirect, logout } = useAuth0()
    const { currentUser } = useCurrentUser()

    if (currentUser) {
        return (
            <NavIconButton onClick={() => logout({ returnTo: window.location.origin })} icon={BoxArrowRight}>SIGN OUT</NavIconButton>
        )
    }

    return (
        <NavIconButton onClick={loginWithRedirect} icon={BoxArrowRight}>SIGN IN</NavIconButton>
    )
}

export default NavLogin